import { fire, auth } from "../../firebase/index";
import { customLog } from "../../variables/Variables";
import { date } from "faker";

const registeredUsersOnPlatformDB = fire
  .database()
  .ref("registeredUsersOnPlatform");

const updateGroupMembers = async (membersToUpdate, groupId, callback) => {
  let membersToUpdateWIthUid = [];
  if (membersToUpdate === null) {
    membersToUpdateWIthUid = null;
  } else {
    membersToUpdateWIthUid = [];
  }

  var dataToCallback = {
    done: true,
    // error: false,
  };

  for (let i = 0; i < membersToUpdate.length; i++) {
    const emailOfGroupMember = membersToUpdate[i].memberEmail;
    // console.log(emailOfGroupMember)
    await registeredUsersOnPlatformDB
      .orderByValue()
      .equalTo(emailOfGroupMember)
      .once("value")
      .then((snapshot) => {
        if (snapshot.exists()) {
          // console.log(snapshot.val())
          snapshot.forEach(async (eachSnapshot) => {
            const uid = eachSnapshot.key;
            const memberEmail = eachSnapshot.val();
            // const currentTime = Date.now()
            // membersToUpdateWIthUid.uid = eachSnapshot.key
            // membersToUpdateWIthUid.memberEmail = eachSnapshot.val()
            membersToUpdateWIthUid[uid] = {
              uid: uid,
              memberEmail: memberEmail,
            };
          });
          customLog(membersToUpdateWIthUid);
        } else {
          dataToCallback = {
            done: false,
            badEmail: emailOfGroupMember,
            // error: true,
          };
          callback(dataToCallback);
          customLog(emailOfGroupMember);
        }
      });
  }
  customLog(membersToUpdateWIthUid);

  // const dataToSend = {
  //   memberEmail: membersToUpdateWIthUid.memberEmail,
  //   uid: membersToUpdateWIthUid.uid,
  //   timeAdded: Date.now(),
  // }
  // console.log(dataToSend)

  if (dataToCallback.done === true) {
    fire
      .database()
      .ref("groupAccounts/" + auth.currentUser.uid + "/userGroups/" + groupId)
      .child("groupMembers")
      .set(membersToUpdateWIthUid);

    callback(dataToCallback);
  }
};

const updateGroupLocks = async (locksToUpdate, groupId, callback) => {
  // const lockData = {
  //   Name: locksToUpdate.Name,
  //   Password: locksToUpdate.Password,
  //   Type: locksToUpdate.Type,
  //   ip45SerialNumber: locksToUpdate.ip45SerialNumber,
  //   lockId: (await groupLockPushRef).key,
  //   isGroupLock: true,
  //   groupId: groupId,
  // };

  let locksToUpdateToDB = [];

  for (var i = 0; i < locksToUpdate.length; i++) {
    var groupLockPushRef = fire
      .database()
      .ref("groupLocks/" + groupId)
      .push();

    locksToUpdateToDB[(await groupLockPushRef).key] = {
      Name: locksToUpdate[i].Name,
      Password: locksToUpdate[i].Password,
      Type: locksToUpdate[i].Type,
      ip45SerialNumber: locksToUpdate[i].ip45SerialNumber,
      lockId: (await groupLockPushRef).key,
      isGroupLock: true,
      groupId: groupId,
    };
    // locksToUpdateToDB.key = (await groupLockPushRef).key;
    // locksToUpdateToDBArray.push(locksToUpdateToDB);
  }

  customLog(locksToUpdateToDB);

  fire
    .database()
    .ref("groupLocks")
    .child(auth.currentUser.uid)
    .child(groupId)
    .set(locksToUpdateToDB);

  var dataToCallback = {
    done: true,
  };
  callback(dataToCallback);
};

export { updateGroupMembers, updateGroupLocks };
